import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../../components/index"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"

import remarkReactComponents from "../../helpers/remarkReactComponents"

const ImageCard = ({ blok, className }) => (
  <SbEditable content={blok}>
    <div className="image-card">
      {blok.imageCard_image &&
        blok.imageCard_image.map((content) =>
          React.createElement(Components(content.component), {
            key: content._uid,
            blok: content,
            className: "image-card__image",
          })
        )}
      <div
        className={[
          "image-card__card",
          "card",
          "card--pd-md",
          blok.card_position ? blok.card_position : className,
        ].join(" ")}
      >
        <div className="">
          {
            unified()
              .use(remarkParse)
              .use(remarkRehype)
              .use(rehypeReact, {
                createElement: React.createElement,
                components: remarkReactComponents,
                Fragment: React.Fragment,
              })
              .processSync(blok.text).result
          }
        </div>
        <div className="image-card__span">{blok.span}</div>
      </div>
    </div>
  </SbEditable>
)

ImageCard.propTypes = {
  blok: PropTypes.shape({
    imageCard_image: PropTypes.arrayOf(PropTypes.object),
    text: PropTypes.string,
    span: PropTypes.string,
    card_position: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
}

export default ImageCard
